// extracted by mini-css-extract-plugin
export default {"familyHistoryForm":"FamilyHistory_familyHistoryForm__uhMMg","fieldLabel":"FamilyHistory_fieldLabel__R9h8J","requiredMark":"FamilyHistory_requiredMark__F7Pbj"};